<template>
  <div @click.stop="toTop" v-show="show" class="block">
    <img src="./../assets/icon/goTop.svg" alt />
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll() {
      let scrollY = window.pageYOffset;
      if (scrollY > 500) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  }
};
</script>

<style scoped>
.block {
  position: fixed;
  width: 4.13rem;
  height: 4.13rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(24, 144, 255, 1);
  border-radius: 2.06rem;
  right: 3.81rem;
  top: 85vh;
}
.block img {
  width: 2.5rem;
  height: 2.5rem;
}
</style>


// WEBPACK FOOTER //
// toTop.vue?c2623cc4